import { MessageCircle, ShieldCheck, Users } from "lucide-react";

const steps = [
    {
        number: "1",
        title: "Play the Game",
        description:
            "Students engage in structured, facilitated dialogue through powerful, scenario-based prompts.",
        icon: MessageCircle,
        color: "bg-[#16bdf4]",
    },
    {
        number: "2",
        title: "Speak the Truth",
        description:
            "They reflect, share, and hear perspectives they may never have considered.",
        icon: Users,
        color: "bg-[#ffbc00]",
    },
    {
        number: "3",
        title: "Build Upstanders",
        description:
            "Students leave with language, confidence, and tools to act differently in real life.",
        icon: ShieldCheck,
        color: "bg-[#22c55e]",
    },
];

export default function SchoolsHowItWorks() {
    return (
        <section className="relative overflow-hidden bg-[#f8f4ea] px-6 py-16 lg:px-8">
            {/* Background image placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{
                    backgroundImage: "url('/assets/schools/how-it-works-bg.png')",
                }}
            />

            <div className="relative mx-auto max-w-6xl">
                <div className="mb-10 text-center">
                    <h2 className="text-4xl font-black uppercase leading-none md:text-5xl">
                        How It Works
                    </h2>

                    <p className="mx-auto mt-4 max-w-2xl text-base font-bold leading-7 md:text-lg">
                        A simple, guided structure that helps students practice real
                        dialogue in a safe and meaningful way.
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-3">
                    {steps.map((step) => {
                        const Icon = step.icon;

                        return (
                            <section
                                key={step.title}
                                className="relative rounded-[24px] border-[4px] border-black bg-white p-5 shadow-[7px_7px_0_#000]"
                            >
                                <div className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border-[3px] border-black bg-[#ff3366] text-lg font-black text-white">
                                    {step.number}
                                </div>

                                <div
                                    className={`mb-5 flex h-14 w-14 items-center justify-center rounded-full border-[3px] border-black ${step.color} shadow-[4px_4px_0_#000]`}
                                >
                                    <Icon size={28} strokeWidth={3} />
                                </div>

                                <h3 className="mb-3 text-2xl font-black uppercase leading-tight">
                                    {step.title}
                                </h3>

                                <p className="text-sm font-bold leading-7 md:text-base">
                                    {step.description}
                                </p>
                            </section>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}